import copy from 'copy-to-clipboard'
import {
  getGlobalSettingsUsingGET as getSettings,
  getGlobalSettingByIdUsingGET as getSingleSetting
} from '@/utils/api'

export const getTenantId = () => (localStorage.getItem('tenantId') || '').toLowerCase()

export const isDefaultTenant = () => getTenantId() === 'default'

// EXECUTE_EXTERNAL_COMMAND only runs on the default tenant (DDEV-5563) -
// keep it out of every step-type picker on other tenants
export const filterTenantStepTypes = (types) =>
  isDefaultTenant() ? types : types.filter((t) => t !== 'EXECUTE_EXTERNAL_COMMAND')

const STEP_CHILD_LISTS = (step) => {
  const props = step?.properties || {}
  const lists = [step?.steps, props.steps, props.parameters?.steps, props.try?.steps, props.finally?.steps]

  ;(props.conditions || []).concat(props.batches || [], props.catch || []).forEach((branch) => lists.push(branch?.steps))

  return lists.filter(Array.isArray)
}

// True on a non-default tenant when the step, or any step nested in it, is an
// EXECUTE_EXTERNAL_COMMAND (DDEV-5564: paste and duplicate must not bring one in)
export const containsExternalCommandStep = (step) => {
  if (isDefaultTenant() || !step || typeof step !== 'object') return false
  if (step.type === 'EXECUTE_EXTERNAL_COMMAND') return true

  return STEP_CHILD_LISTS(step).some((list) => list.some(containsExternalCommandStep))
}

export const stripTenantPrefix = (str, prefix) => {
  if (!str) return ''
  if (prefix) {
    const lower = str.toLowerCase()
    const prefixLower = prefix.toLowerCase()
    if (lower.startsWith(prefixLower)) {
      str = str.slice(prefix.length)
    }
  }
  if (str.startsWith('/')) {
    str = str.slice(1)
  }
  return str
}

export const copyTriggerUrl = async ({ storedPath, addSnackbar, lang, pathPrefix }) => {
  try {
    const res = await getSettings()
    const data = res.data.data.find((x) => x.type === 'FRONTEND')

    if (!data) {
      addSnackbar({
        message: lang.errors.noFeSettings,
        timeout: 5000,
        color: 'error'
      })
      return
    }

    const res2 = await getSingleSetting({ id: data.id })
    const baseUrl = res2.data.data.values.baseUrlRest.replace(/\/$/, '')
    const tenantId = getTenantId()
    const isDefault = isDefaultTenant()

    let cleanPath = storedPath || ''
    if (pathPrefix) {
      cleanPath = cleanPath.replace(/^\//, '')
      if (cleanPath.toLowerCase().startsWith(pathPrefix.toLowerCase() + '/')) {
        cleanPath = cleanPath.slice(pathPrefix.length + 1)
      }
    }
    cleanPath = stripTenantPrefix(cleanPath, tenantId)
    cleanPath = cleanPath.replace(/^\/+/, '')

    const segments = [baseUrl.replace(/\/+$/, ''), pathPrefix, isDefault ? '' : tenantId, cleanPath]
    const finalUrl = segments.filter(Boolean).join('/')

    copy(finalUrl)

    addSnackbar({
      message: lang.success.copiedClipboard,
      timeout: 5000,
      color: 'success'
    })
  } catch (error) {
    console.log(error)
  }
}
